// extracted by mini-css-extract-plugin
export default {"grid":"GameOfLifeGrid_grid__C0AkF","menu":"GameOfLifeGrid_menu__Rbg24"};